import { render, staticRenderFns } from "./findpassword.vue?vue&type=template&id=6008966e&"
import script from "./findpassword.vue?vue&type=script&lang=js&"
export * from "./findpassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports